const actions = {
  getTournamentList: 'GET_TROUNAMENT_LIST',
  deleteTournament: 'DELETE_TOURNAMENT',
  getTournamentBanners: 'GET_TOURNAMENT_BANNERS',
  getTournamentCreators: 'GET_TOURNAMENT_CREATORS',
  setTournamentDialogVisibilityState: 'SET_TOURNAMENT_DIALOG_VISIBILITY_STATE',
};

export default actions;
